import type { ComponentDocs } from '@ui/components/helpers';

export const icLoadingBarDocs: ComponentDocs = {
  selector: 'ic-loading-bar',
  status: 'adopted',
  source: 'others',
  scope: 'app',
  family: 'layout',

  outputs: [],

  directives: [],

  services: [
    {
      name: 'FuseLoadingService',
      description:
        'Servicio root que gobierna la barra. La barra solo lo observa: quien quiera mostrarla o mover el progreso lo hace por aquí, no por inputs',
      methods: [
        { name: 'show', signature: '() => void', description: 'Muestra la barra' },
        { name: 'hide', signature: '() => void', description: 'Oculta la barra' },
        {
          name: 'setMode',
          signature: "(value: 'determinate' | 'indeterminate') => void",
          description: 'Alterna entre progreso conocido y animación continua',
        },
        {
          name: 'setProgress',
          signature: '(value: number) => void',
          description: 'Fija el progreso entre 0 y 100. Solo tiene efecto en modo determinate',
        },
      ],
    },
  ],

  cssTokens: [
    { name: '--ic-loading-bar-height', default: '6px', description: 'Alto de la barra' },
    { name: '--ic-loading-bar-z-index', default: '999', description: 'Capa de apilado sobre el resto del chrome' },
  ],

  subcomponents: [],

  internals: [],

  externalDeps: ['FuseLoadingService'],

  demos: [
    {
      slug: 'default',
      label: 'Default',
      loader: () =>
        import('app/modules/admin/examples/demos/others/loading-bar/demos/default/demo-loading-bar--default.component')
          .then(m => m.DemoLoadingBarDefaultComponent),
    },
  ],
};
